routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
    $stateProvider
        .state('home.contactDetailId', {
            url: __env.routes.contactDetailId,
            template: `<contact-detail sh-ctrl="shCtrl"></contact-detail>`
        });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/contact-detail/contact-detail.config.js